export function request (params) {
  return {
    companyName: 'OTC Markets',
    logoUrl: null,
    sponsor: 'Mock Data',
    symbol: 'Mock Data'
  }
}
